// Source of truth for the Terms of Service shown at /terms-of-service.
// Edit THIS file to change the terms text - no component/layout code
// needs to change. Keep the '**Last Updated: ...**' line current whenever
// the content meaningfully changes.
const termsOfServiceContent = `# Terms of Service

**Last Updated: July 31, 2026**

## 1. Acceptance of Terms

These Terms of Service ("Terms") govern your access to and use of Justice Genie (the "Service"), independently developed and operated by Yaganti Subhash and Vemula Siri Mahalaxmi. By creating an account or otherwise using the Service, you agree to be bound by these Terms. If you do not agree, please do not use the Service.

## 2. Description of Service

Justice Genie provides an AI-powered conversational assistant for general legal information, an automated case-strength analysis tool, an interactive legal-knowledge quiz, and a reference document library, with a focus on Indian law.

## 3. Educational Purpose Only

**Justice Genie is not a law firm and does not provide legal advice.**

- No attorney-client relationship is created by using the Service.
- Responses are generated using artificial intelligence and may be incomplete, inaccurate, or outdated.
- The case-strength analysis feature is an automated estimate only and is not a prediction of any actual legal outcome.
- You should independently verify any important information and consult a licensed legal professional in your jurisdiction before making decisions based on information obtained through the Service.
- We are not liable for outcomes resulting from reliance on information provided by the Service.

## 4. Eligibility

You must be at least 18 years old to create an account and use the Service.

## 5. User Accounts

You are responsible for maintaining the confidentiality of your account credentials and for all activity occurring under your account. You agree to provide accurate information when creating your account and to notify us promptly of any suspected unauthorized access.

## 6. Acceptable Use

You agree not to:
- Use the Service for any unlawful purpose or to facilitate illegal activity
- Engage in fraud, impersonation, or misrepresentation
- Scrape, reverse-engineer, or extract data from the Service at scale
- Introduce malware, attempt phishing, or send spam through the Service
- Send unsolicited automated traffic or bypass rate limits and security controls
- Attempt unauthorized access to any account, system, or data
- Exploit vulnerabilities in the Service
- Interfere with the availability or normal operation of the Service
- Infringe the intellectual property rights of Justice Genie or others
- Engage in abusive, harassing, or threatening behavior toward other users or the operators

We reserve the right to suspend or terminate accounts that violate these Terms.

## 7. User Content

You retain ownership of the content you submit to the Service ("User Content"). By submitting User Content, you grant Justice Genie a limited license to use, store, and process it solely as necessary to operate, maintain, and improve the Service.

## 8. AI-Generated Content

Content generated by the Service's AI features may be inaccurate, incomplete, or outdated, and should not be solely relied upon for any decision. You remain fully responsible for any actions taken based on AI-generated content.

## 9. Intellectual Property

Justice Genie owns all rights to the Service's software, user interface, branding, and proprietary content, except where otherwise noted. Third-party materials referenced or made available through the Service (such as reference legal documents) remain the property of their respective owners.

## 10. Feedback

Any feedback, ideas, or suggestions you provide regarding the Service may be used by Justice Genie without obligation or compensation to you.

## 11. Availability and Beta Features

Features of the Service may be added, modified, or discontinued at any time. Features identified as beta or experimental are provided for evaluation purposes and may change or be removed without notice.

## 12. Third-Party Services

The Service depends on third-party providers, including AI, authentication, hosting, storage, and email service providers, as described in our Privacy Policy. We are not responsible for interruptions or issues originating from these third-party providers, though we will make reasonable efforts to address their impact on the Service.

## 13. Disclaimer

The Service is provided "as is" and "as available," without warranties of any kind, express or implied, including but not limited to warranties of accuracy, reliability, or fitness for a particular purpose.

## 14. Limitation of Liability

To the maximum extent permitted by law, Justice Genie and its operators shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service. Where the Service is offered free of charge, liability is limited to the maximum extent permitted by applicable law. Should paid plans be introduced in the future, liability under these Terms will be limited to the amount, if any, paid by you to Justice Genie in the twelve (12) months preceding the claim.

## 15. Indemnification

You agree to indemnify and hold Justice Genie and its operators harmless from any claims, losses, or damages arising from your misuse of the Service or violation of these Terms.

## 16. Suspension and Termination

Justice Genie may suspend or terminate your access to the Service at its discretion in cases of violation of these Terms, abuse, fraud, or security concerns. You may stop using the Service and delete your account at any time.

## 17. Changes to These Terms

We may update these Terms from time to time. Material changes will be reflected by updating the date above. Continued use of the Service after changes constitutes acceptance of the updated Terms.

## 18. Governing Law

These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Hyderabad, Telangana.

## 19. Severability

If any provision of these Terms is found unenforceable, the remaining provisions will continue in full force and effect.

## 20. Waiver

No failure or delay by Justice Genie in exercising any right under these Terms shall constitute a waiver of that right.

## 21. Entire Agreement

These Terms, together with our Privacy Policy, constitute the entire agreement between you and Justice Genie regarding use of the Service, superseding any prior agreements.

## 22. Contact Us

Questions regarding these Terms may be directed to:

**justicegenie2.0@gmail.com**
`;

export default termsOfServiceContent;
